import { scrollAnimation } from './function/scroll-animation.js';
const tile = require('./function/tile.js');
const slick = require('/assets/js/slick/slick.js');
import '/assets/js/common.js';
import '/assets/js/slick/slick.css';
import '/assets/css/_common.scss';
import '/assets/css/after-service.scss';


// ===========================================
// 各サービス名の行数に応じたレイアウト調整
// ===========================================
$(function () {
  let beforeWidth = $(window).width();

  function heightSet( ttl ) {
    ttl.css({ height: 'auto' });

    if( $(window).width() > 640 ) {
      ttl.tile(2);
    }
  }

  if( $('.detailTtlSub').length ) {
    heightSet( $('.detailTtlSub') );

    $(window).on('resize', function(){
      if( beforeWidth !== $(window).width() ) {
        heightSet( $('.detailTtlSub') );
      }
    });
  }
});